import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressBarModule } from 'primeng/progressbar';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { RouterModule } from '@angular/router';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { FooterComponent } from './main-layout/footer/footer.component';
import { LayoutComponent } from './main-layout/layout.component';
import { MainComponent } from './main-layout/main/main.component';
import { AuthNoticeComponent } from './main-layout/auth-notice/auth-notice.component';
import { SidebarComponent } from './main-layout/sidebar/sidebar.component';
import { TopbarComponent } from './main-layout/topbar/topbar.component';
import { LoginComponent } from './auth-layout/login/login.component';
import { ForgotPasswordComponent } from './auth-layout/forgot-password/forgot-password.component';
import { RegisterComponent } from './auth-layout/register/register.component';
import { ConfirmEmailComponent } from './auth-layout/confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './auth-layout/reset-password/reset-password.component';
import { AuthLayoutComponent } from './auth-layout/auth-layout.component';
import { SharedModule } from '../shared/shared.module';
import { PopoverModule } from 'primeng/popover';
import { DividerModule } from 'primeng/divider';
import { ToastModule } from 'primeng/toast';
import { PasswordModule } from 'primeng/password';
import { CheckboxModule } from 'primeng/checkbox';
import { SkeletonModule } from 'primeng/skeleton';
import { FormsModule } from '@angular/forms';
@NgModule({
  declarations: [
    LayoutComponent,
    FooterComponent,
    BreadcrumbsComponent,
    TopbarComponent,
    SidebarComponent,
    MainComponent,
    AuthNoticeComponent,
    LoginComponent,
    ForgotPasswordComponent,
    RegisterComponent,
    ConfirmEmailComponent,
    ResetPasswordComponent,
    AuthLayoutComponent,
  ],
  imports: [
    CommonModule,
    AvatarModule,
    ButtonModule,
    BadgeModule,
    ChartModule,
    InputTextModule,
    ProgressBarModule,
    TableModule,
    TagModule,
    RouterModule,
    BreadcrumbModule,
    SharedModule,
    PopoverModule,
    DividerModule,
    ToastModule,
    PasswordModule,
    CheckboxModule,
    SkeletonModule,
    FormsModule,
  ],
  exports: [LayoutComponent, AuthLayoutComponent],
})
export class LayoutModule {}
